"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
function useWatchingFocus(inputRef) {
    const [focused, setFocused] = (0, react_1.useState)(false);
    const hasInput = !!inputRef.current;
    (0, react_1.useEffect)(function watchFocusEffect() {
        const input = inputRef.current;
        if (!input) {
            return;
        }
        if (document.activeElement === input) {
            setFocused(true);
        }
        function onFocus() {
            setFocused(true);
        }
        function onBlur() {
            setFocused(false);
        }
        input.addEventListener('focus', onFocus, libs_polyfills_1.optionsWithPassive);
        input.addEventListener('blur', onBlur, libs_polyfills_1.optionsWithPassive);
        return function cleanupEvents() {
            input.removeEventListener('focus', onFocus);
            input.removeEventListener('blur', onBlur);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasInput, inputRef, inputRef.current]);
    return {
        focused,
    };
}
exports.default = useWatchingFocus;
//# sourceMappingURL=useWatchingFocus.js.map